import TESVG from './TESVG';

export default TESVG;
